







































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Button from '@/types/components/Button.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListTile from '@/types/components/IListTile.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import ShortLink from '@/types/ShortLink.interface'
export default Vue.extend({
    data() {
        return {
            routesListPlaceholder: {
                content: 'No Short Links Found',
                img: 'noMessages'
            },
            toolbar: {
                title: 'Link Analytics',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/plugins',
                        tooltip: 'Back',
                        permission: 0
                    }
                ],
                right: []
            }
        }
    },
    computed: {
        ...mapGetters({
            routesParams: 'routesViewRoutesParams',
            lastPage: 'routesViewRoutesLastPage',
            scrollPositionLeft: 'scrollPositionLeft',
            paginating: 'routesViewPaginating',
            routes: 'routesViewRoutes'
        }),
        containerStyle() {
            let width = '55%'

            //  If we are on large screens, use 80%
            if (this.$vuetify.breakpoint.lgOnly) width = '80%'

            //  If we are on small or smaller, use 100%
            if (this.$vuetify.breakpoint.mdAndDown) width = '100%'

            //  Return our style
            return {
                maxWidth: width
            }
        },
        counts(): object[] {
            return [
                {
                    count: this.sentCount,
                    subtitle: 'links sent'
                },
                {
                    count: this.openCount,
                    subtitle: 'links opened'
                }
            ]
        },
        localLink(): string {
            if (!this.selectedRoute) return null

            //  Else, remove https:// from our link
            const str = this.selectedRoute.local_link

            return str.replace('https://', '')
        },
        openCount(): number {
            if (!this.selectedRoute) return null

            //  Else, grab our open array
            const open = this.selectedRoute.clicked || []

            //  Return the count
            return open.length
        },
        openHeight(): string {
            //  If our open count is 0, just return 0
            if (!this.openCount) return '0'

            //  If our sent count is 0 but open count isn't, return 200
            if (!this.sentCount && this.openCount > 0) return '200px'

            //  If our open count is greater than our sent count, just return 200
            if (this.openCount > this.sentCount) return '200px'

            //  Find percentage between our two heights
            const percent = this.openCount / this.sentCount

            //  Grab this percent of 200 since total height it can be is 200px
            const total = Math.floor(200 * percent)

            //  Return our percent diff
            return `${total}px`
        },
        openRate(): number {
            //  Else, if open count is 0 return 0
            if (!this.openCount) return 0

            //  If sent count is 0 but open count isn't return 100
            if (!this.sentCount && this.openCount > 0) return 100

            //  If open count is greater than sent count, return 100
            if (this.openCount > this.sentCount) return 100

            //  Else, return our math function
            return Math.floor((this.openCount / this.sentCount) * 100)
        },
        sentCount(): number {
            if (!this.selectedRoute) return null

            //  Else, grab our sent array
            const sent = this.selectedRoute.sent || []

            //  Return the count
            return sent.length
        },
        sentHeight(): string {
            //  If our sent count is 0, just return 0
            if (!this.sentCount) return '0'

            //  If our open count is 0 but sent count isn't, return 200
            if (!this.openCount && this.sentCount > 0) return '200px'

            //  If our sent count is greater than our open count, just return 200
            if (this.sentCount > this.openCount) return '200px'

            //  Find percentage between our two heights
            const percent = this.sentCount / this.openCount

            //  Grab this percent of 200 since total height it can be is 200px
            const total = Math.floor(200 * percent)

            //  Return our percent diff
            return `${total}px`
        },
        selectedRoute: {
            get(): ShortLink {
                return this.$store.getters.routesViewSelectedRoute
            },
            set(val: ShortLink): void {
                this.$store.commit('routesViewSelectedRouteSet', val)
            }
        }
    },
    methods: {
        copyRoute(route: ShortLink): void {
            //  Grab the element containing the short link
            const elem = document.getElementById(`item-${route.id}-line-3`)

            //  Create a range to copy our element text (akin to selecting)
            const range = document.createRange()

            //  Set our range on target div
            range.selectNode(elem)

            //  Clear any currently selected text
            window.getSelection().removeAllRanges()

            //  Select our divs text
            window.getSelection().addRange(range)

            //  Copy to our clipboard
            document.execCommand('copy')

            //  Deselect our divs text
            window.getSelection().removeAllRanges()

            //  Notify our user with toast
            this.$store.commit('appNotificationBarSet', {
                message: 'Short Link Copied to Clipboard!',
                type: 'success'
            })
        },
        onRouteSelected(route: ShortLink): void {
            //  Set the step to 2 (for mobile layout only)
            this.$refs.routesPanel.step = 2

            //  Check if the route is different form the currently selected route
            const isNew = !this.selectedRoute || this.selectedRoute.id != route.id

            //  If the channel is NOT different fromt he current selectetd person, do nothing
            if (!isNew) return

            //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
            const query = Object.assign({}, this.$route.query)

            //  Update the route query param (there is watcher on this value that handles fetching the person)
            query.id = route.id

            //  Update the current url
            this.$router.push({ query })
        },
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.routesParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage
            this.$store.commit('routesViewRoutesParamsSet', params)

            //  Paginate the next page
            this.$store.dispatch('routesViewRoutesPaginate')
        },
        popRouteForm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'short-link-popup',
                width: '670px',
                radius: '16px',
                closeable: true
            })
        },
        routeActions(route: ShortLink): IListAction {
            //  Create our menu of buttons
            const menu: Button[] = [
                {
                    icon: 'mdi-content-copy',
                    text: 'Copy Route',
                    color: 'primary',
                    callback: () => this.copyRoute(route)
                },
                {
                    icon: 'bi-trash-fill',
                    text: 'Delete Route',
                    color: 'primary',
                    hidden: route.type !== 'web',
                    callback: () => this.routeDeleteConfirm(route)
                }
            ]

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  Return our action
            return action
        },
        async routeDelete(route: ShortLink): Promise<void> {
            //  Send our request
            const response = await this.$store.dispatch('routesDelete', route.id)

            //  If no response, do nothing
            if (!response) return

            //  Else, pop notification bar
            this.$store.commit('appNotificationBarSet', {
                message: 'Route Deleted.',
                type: 'success'
            })
        },
        routeDeleteConfirm(route: ShortLink): void {
            //  Ask user if they are sure they want to delete route
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Short Link?',
                text: 'Are you sure you want to delete this short link?',
                icon: 'mdi-alert',
                color: 'red darken-2',
                callback: (result: boolean): void => {
                    if (result) this.routeDelete(route)
                }
            })
        },
        routeIcon(route: ShortLink): IListIcon {
            //  Get our icon depending on what type of route this is
            const icon = this.$options.filters.routeIcon(route)

            //  Create our list icon
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our icon
            return listIcon
        },
        routeIconText(route: ShortLink): string {
            //  Just use a pseudo switch
            return (
                {
                    form: 'Forms',
                    invoice: 'Invoice',
                    web: 'Web'
                }[route.type] || 'Media'
            )
        },
        routesTile(): IListTile {
            return {
                actionContent: (route: ShortLink) => this.routeActions(route),
                leftIcon: (route: ShortLink) => this.routeIcon(route),
                leftFooter: (route: ShortLink) => this.routeIconText(route),
                line1: (route: ShortLink): string => route.token,
                line2: (route: ShortLink): string =>
                    route.clicked ? `${route.clicked.length} Clicks` : '0 Clicks',
                line3: (route: ShortLink): string => route.local_link,
                callback: (route: ShortLink) => this.onRouteSelected(route)
            }
        }
    },
    watch: {
        $route(to, from): void {
            //  If the 'id' query param does NOT exist, unset our data
            if (!to.query.id) return (this.selectedRoute = null)

            //  Else, grab the id
            const id = to.query.id

            //  Check if we need to load this route
            const needsLoad = !this.selectedRoute || id != this.selectedRoute.id

            //  If we do NOT need to load, do nothing
            if (!needsLoad) return

            //  Else, get our route
            this.$store.dispatch('routesViewSelectedRouteGet', id)
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
